import { render } from "./AddLanguageFlow.vue?vue&type=template&id=b391b50c&scoped=true"
import script from "./AddLanguageFlow.vue?vue&type=script&lang=js"
export * from "./AddLanguageFlow.vue?vue&type=script&lang=js"

import "./AddLanguageFlow.vue?vue&type=style&index=0&id=b391b50c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b391b50c"]])

export default __exports__